import { setCookie } from "../cookie-helper";

const modal = document.querySelector('#invest-consent-modal');

if (modal) {
    const consentForm = modal.querySelector('.modal__invest-consent-form');

    consentForm.addEventListener("submit", (e) => {
        e.preventDefault();

        // Set cookie
        setCookie("f5-invest-consent", "true", 7);

        // Hide modal
        modal.setAttribute("aria-hidden", "true");
        document.body.classList.remove("overflow-hidden");
    });
}